import React from 'react';
import Image from 'next/image';
import { Box, Modal, IconButton, CircularProgress, Alert } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';

function ModalBild({ imageSrc, altText, width, height }) {
  const [loading, setLoading] = React.useState(true);
  const [failed, setFailed] = React.useState(false);

  return (
    <>
      {loading && <CircularProgress aria-label="Bild lädt" sx={{ position: 'absolute', top: '50%', left: '50%' }} />}
      {failed ? <Alert severity="error">Das Bild konnte nicht geladen werden.</Alert> : (
        <Image
          src={imageSrc}
          alt={altText}
          width={width}
          height={height}
          onLoad={() => setLoading(false)}
          onError={() => { setLoading(false); setFailed(true); }}
          style={{ width: 'auto', height: 'auto', maxWidth: '92vw', maxHeight: '85dvh', objectFit: 'contain' }}
        />
      )}
    </>
  );
}

const buttonStyle = {
  position: 'absolute', zIndex: 1,
  backgroundColor: 'rgba(0, 0, 0, 0.5)', color: 'white',
  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
};

export default function ImageModal({ isOpen, onClose, imageSrc, altText, width = 800, height = 600, next, previous }) {
  return (
    <Modal open={isOpen} onClose={onClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box
        role="dialog" aria-modal="true" aria-label={altText || 'Projektbild'} tabIndex={-1}
        onKeyDown={(event) => {
          const action = event.key === 'ArrowRight' ? next : event.key === 'ArrowLeft' ? previous : null;
          if (action) { event.preventDefault(); action(); }
        }}
        sx={{ position: 'relative', outline: 'none', minWidth: 120, minHeight: 80 }}
      >
        <IconButton aria-label="Bild schliessen" onClick={onClose} sx={{ ...buttonStyle, right: 0, top: 0 }}>
          <CloseIcon />
        </IconButton>
        {previous && <IconButton aria-label="Vorheriges Bild" onClick={previous} sx={{ ...buttonStyle, left: 0, top: '50%' }}><ArrowBackIcon /></IconButton>}
        {imageSrc && <ModalBild key={imageSrc} imageSrc={imageSrc} altText={altText} width={width} height={height} />}
        {next && <IconButton aria-label="Nächstes Bild" onClick={next} sx={{ ...buttonStyle, right: 0, top: '50%' }}><ArrowForwardIcon /></IconButton>}
      </Box>
    </Modal>
  );
}
